<template>
  <div>
    <el-table v-if="whitelist.data && whitelist.data.length"
      :data="whitelist.data"
      :default-sort="{ prop: order_column, order: order_type }"
      class="w100 allowlist-table"
      stripe
      v-loading="loading"
      @sort-change="sort"
    >
      <el-table-column width="100">
        <template #header>
          <el-checkbox @change="toggleSelectAll" class="checkbox-channel"></el-checkbox>
          <span>
            {{ selectedAllChannels ? whitelist.total : selectedChannels.length }} / {{ whitelist.total || 0 }}
          </span>
        </template>
        <template #default="props">
          <el-checkbox :label="props.row.channelId" :value="props.row.channelId"
              v-model="selectedChannels" class="checkbox-channel"></el-checkbox>
        </template>
      </el-table-column>
      <el-table-column width="100%">
        <template slot-scope="props">
          <img
            v-if="props.row.image_url"
            class="avatar"
            :src="props.row.image_url"
          />
          <img
            v-else
            class="avatar"
            :src="`https://syncvault.com/static/apple-touch-icon.png`"
          />
        </template>
      </el-table-column>
      <el-table-column
        label="Channel"
        prop="channelId"
        sortable="custom"
      ></el-table-column>
      <el-table-column label="Title" prop="title" sortable="custom"></el-table-column>
      <el-table-column label="Labels">
        <template slot-scope="props">
          <span v-if="props.row.label_ids && props.row.label_ids.length">
            {{ props.row.label_ids.map(id => getLabelNameById(id)).join(', ') }}
          </span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column label="Published" prop="published_at" sortable="custom">
        <template slot-scope="props">
          {{ props.row.published_at | date }}
        </template>
      </el-table-column>
      <el-table-column label="Added" prop="created_at" sortable="custom">
        <template slot-scope="props">
          {{ props.row.created_at | date }}
        </template>
      </el-table-column>
      <el-table-column label="Status" prop="status">
        <template slot-scope="props">
          <el-tag v-if="props.row.status === 3" type="warning">
            Delete Request
          </el-tag>
          <el-tag v-else-if="props.row.status === 2" type="info">
            Insert Request
          </el-tag>
          <el-tag v-else-if="props.row.status === 1" type="success">
            Active
          </el-tag>
          <el-tag v-else-if="props.row.status === 0" type="danger">
            Disabled
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="Actions" align="right" width="115" >
        <template slot-scope="props">
          <div style="display:flex;">
          <el-tooltip content="Review" placement="top">
            <el-button
                type="info"
                circle
                size="small"
                icon="el-icon-edit"
                @click="openEdit(props.row)"
            ></el-button>
          </el-tooltip>
          <el-tooltip content="Disable" placement="top">
            <el-button
                type="danger"
                size="small"
                :disabled="props.row.isDisabled"
                @click="deleteW(props.row)"
            >
              Disable
            </el-button>
          </el-tooltip>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <p v-else class="align-center">
      No data
    </p>
    <el-pagination
      class="float-right"
      background
      @current-change="currentChange"
      :current-page.sync="whitelist.current_page"
      :page-size="page_size"
      layout="total, prev, pager, next, jumper"
      :total="whitelist.total"
    ></el-pagination>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'

export default  {
  data() {
      return {
        selectedChannels: []
      }
  },
  computed: {
    ...mapState('youtubeWhitelist', [
      'whitelist',
      'loading',
      'order_column',
      'order_type',
      'page_size',
      'selectedAllChannels',
      'labels'
    ])
  },

  watch: {
    selectedChannels(newVal) {
      console.log('selectedChannels:', newVal);
      this.setSelectedChannels(newVal)
    }
  },

  methods: {
    ...mapMutations('youtubeWhitelist', ['setPage','setDialogEdit','setSelectedChannel',"setOrdering", 'setSelectedChannels', 'setSelectedAllChannels']),
    ...mapActions('youtubeWhitelist', ['readWhitelist', 'destroy','getLabels']),
    currentChange(currentPage) {
      this.setPage(currentPage)
      this.readWhitelist()
    },
    sort(d) { console.log(d)
      this.setOrdering({
        column: d.prop,
        type: this.ascDesc(d.order)
      })
      this.readWhitelist()
    },
    deleteW(row) {
      this.$confirm(
        'You will disable this channel from whitelist. Continue?',
        'Warning',
        {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }
      )
        .then(() => {
          this.destroy([row.channelId])
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: 'Disable cancelled'
          })
        })
    },

    toggleSelectAll(value) {
      if (value) {
        this.selectedChannels = this.whitelist.data.map(_ => _.channelId)
        this.setSelectedAllChannels(true)
      } else {
        this.selectedChannels = []
        this.setSelectedAllChannels(false)
      }
    },
    openEdit(row) {
      this.setSelectedChannel(row)
      this.setDialogEdit(true)
    },
    getLabelNameById(labelId) {
      const label = this.labels.find(label => label.id === labelId);
      return label ? label.name : 'Unknown';
    }
  },

  created() {
    this.readWhitelist()
    this.getLabels()
  }
}
</script>

<style lang="scss">
.allowlist-table {

  .checkbox-channel .el-checkbox__label {
    display: none;
  }

  .el-checkbox__inner::after {
    height: 10px;
    left: 7px;
  }

  .checkbox-channel {
    display: flex;

    span {
      width: 20px;
      height: 20px;
      border-color: #e55279;
    }
  }
}
</style>
